.add-card-icon {
    font-size: 50px;
    line-height: 31px; /* Custom line height for this jank plus sign */
    margin-bottom: 16px;
}

.add-card-label {
    font-size: var(--font-small);
}
